var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlnkC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.001,
    height: 168,
    viewBox: "0 0 168.001 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC81C\\uC678_4",
    "data-name": "\\uC81C\\uC678 4",
    d: "M-5125,168a83.468,83.468,0,0,1-32.7-6.6,83.937,83.937,0,0,1-14.27-7.745A84.558,84.558,0,0,1-5184.4,143.4a84.538,84.538,0,0,1-10.258-12.432A83.962,83.962,0,0,1-5202.4,116.7,83.478,83.478,0,0,1-5209,84a83.481,83.481,0,0,1,6.6-32.7,83.965,83.965,0,0,1,7.745-14.269A84.536,84.536,0,0,1-5184.4,24.6a84.552,84.552,0,0,1,12.432-10.257A83.933,83.933,0,0,1-5157.7,6.6,83.468,83.468,0,0,1-5125,0a83.467,83.467,0,0,1,32.7,6.6,83.959,83.959,0,0,1,14.27,7.745A84.657,84.657,0,0,1-5065.6,24.6a84.57,84.57,0,0,1,10.258,12.432A84.038,84.038,0,0,1-5047.6,51.3,83.48,83.48,0,0,1-5041,84a83.477,83.477,0,0,1-6.6,32.7,84.035,84.035,0,0,1-7.744,14.269A84.565,84.565,0,0,1-5065.6,143.4a84.662,84.662,0,0,1-12.432,10.257,83.964,83.964,0,0,1-14.27,7.745A83.467,83.467,0,0,1-5125,168Zm0-136.168A52.228,52.228,0,0,0-5177.169,84,52.227,52.227,0,0,0-5125,136.168,52.227,52.227,0,0,0-5072.832,84,52.227,52.227,0,0,0-5125,31.832Z",
    transform: "translate(5209.001)",
    fill: "#a67744",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlnkC);
export default __webpack_public_path__ + "static/media/blnk_c.03ffa7dcd7df49f4cfe1640f93a7fd8b.svg";
export { ForwardRef as ReactComponent };